export const getContentToDisplay = (content: any) => {
  if (!content) {
    return { contentImageStringType: null, contentDisplay: null };
  }
  const contentImageStringType = content.includes("filename:")
    ? "base64"
    : content?.startsWith("<img")
    ? "html"
    : content?.startsWith("https://")
    ? "url"
    : "fileName";

  const contentDisplay =
    contentImageStringType === "base64"
      ? content?.split(";")[2].split(":")[1]
      : contentImageStringType === "html"
      ? getAltAttribute(content)
      : contentImageStringType === "url"
      ? content.split("/").pop()?.replace(/\?.*$/, "")
      : content;

  return { contentImageStringType, contentDisplay };
};

function getAltAttribute(htmlString: string): string | null {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  const imgElement = tempDiv.querySelector("img");
  return imgElement?.getAttribute("alt") || null;
}
